// extracted by mini-css-extract-plugin
export var container = "_9m-0";
export var error = "_9m-9";
export var label = "_9m-5";
export var light = "_9m-6";
export var md = "_9m-3";
export var sm = "_9m-2";
export var thin = "_9m-8";
export var thinBold = "_9m-7";
export var vertical = "_9m-4";
export var xs = "_9m-1";